module.exports = __webpack_public_path__ + "img/motor.450af374.png";